var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#paint0_linear_1_7)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 38C14 38 20.5 43 28.5 43C36.5 43 42 38 42 38",
    stroke: "url(#paint1_linear_1_7)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.9991C15 20.8325 18.9 19.1991 22.5 21.9991",
    stroke: "url(#paint2_linear_1_7)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.546C36.5 21.3794 40.4 19.746 44 22.546",
    stroke: "url(#paint3_linear_1_7)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7",
    x1: 59,
    y1: 40.5,
    x2: 3,
    y2: -6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CFF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2FF83",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7",
    x1: 15.2923,
    y1: 40.2391,
    x2: 23.8669,
    y2: 26.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38E235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7",
    x1: 13.9154,
    y1: 21.1455,
    x2: 16.5191,
    y2: 16.7383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38E235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_7",
    x1: 35.4154,
    y1: 21.6923,
    x2: 38.0191,
    y2: 17.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38E235"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowSmile);
export default __webpack_public_path__ + "static/media/grow_smile.71531e7a67e0640ab6e7904be537ac58.svg";
export { ForwardRef as ReactComponent };